import React from 'react'
import useUserActivityHooks from '../../../../customHooks/usermanagement/useUserActivityHooks'
import TimeLineItem, { ActivityLogItem } from './TimeLineItem'
import ATModuleMessage from '../../../common/message/ATModuleMessage'

interface UserActivityLogProps {
  selectedUserId?: number
  userCode?: string
}

const UserActivityLog: React.FC<UserActivityLogProps> = ({
  selectedUserId,
  userCode,
}) => {
  const { userActivityData, isloadingActivityData } = useUserActivityHooks(
    selectedUserId,
    userCode,
  )

  if (!isloadingActivityData && userActivityData.length === 0) {
    return <ATModuleMessage />
  }

  return (
    <div className="overflow-auto">
      {userActivityData?.map((item: ActivityLogItem) => {
        return (
          <TimeLineItem key={item.eventKey} item={item} isUserActivity={true} />
        )
      })}
    </div>
  )
}

export default UserActivityLog
